<template>
  <div>
    <div class="index_nav_div">
      <div class="bg_div">
        <!---------面包屑导航---------->
        <table
          cellpadding="0"
          cellspacing="0"
          style="border-width: 0; padding: 0px"
          border="0"
        >
          <tbody>
            <tr style="border-width: 0" border="0">
              <th style="border-width: 0; padding: 0px" border="0">&nbsp;</th>
              <td style="border-width: 0; padding: 0px" border="0" class="td_y">
                当前所在位置：
                <template v-for="(item, index) in breadCrumb">
                  <RouterLink :to="index == 0 ? '/' : '/detail?' + item.path">{{
                    item.name
                  }}</RouterLink
                  ><span v-if="index < breadCrumb.length - 1"
                    >&nbsp;》&nbsp;</span
                  >
                </template>
              </td>
              <td
                style="border-width: 0; padding: 0px"
                border="0"
                class="td_bg"
              >
                &nbsp;
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div id="content">
        <div class="news clearfix">
          <div class="jglb_151126">
            <div class="left">
              <div class="link">
                <a>{{ leftMenu.menuName }}</a>
              </div>
              <ul id="wucLeftList_ul2">
                <li
                  v-for="item in leftMenu.menuVOS"
                  :key="item.id"
                  :class="{ cur: item.menuUrl === currMenu }"
                >
                  <a @click="goDetail(item.menuUrl)" target="_self">{{
                    item.menuName
                  }}</a>
                </li>
              </ul>
            </div>

            <div class="right">
              <div class="cont" style="display: block">
                <div class="mbox_data ql-editor" v-if="isLeaf == 1">
                  <div
                    v-html="textContent"
                    class="data"
                    style="min-height: 500px"
                  ></div>
                </div>
                <div v-else>
                  <div
                    style="
                      border-left: 1px solid #ccc;
                      margin-top: -30px;
                      padding-left: 20px;
                    "
                  >
                    <el-table :data="tableData" style="width: 100%">
                      <el-table-column prop="title">
                        <template #default="scope">
                          <el-link @click="goArticle(scope.row.threadId)">
                            {{ scope.row.title }}
                          </el-link>
                        </template>
                      </el-table-column>
                      <el-table-column prop="createTime" width="100" />
                    </el-table>
                  </div>
                  <pagination
                    :total="total"
                    v-model:page="queryParams.page"
                    v-model:limit="queryParams.size"
                    @pagination="getList"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getDetailInfo, getListContent } from "@/api/home";
const { proxy } = getCurrentInstance();
const route = useRoute();
const router = useRouter();
let currMenu = ref("");
let subMenus = ref({});
let menuName = ref("");
let textContent = ref("");
let leftMenu = ref({});
let isLeaf = ref(false);
let tableData = ref([]);
let breadCrumb = ref([]);
let total = ref(0);
let queryParams = ref({
  page: 1,
  size: 10,
});
let queryP = ref({});
watch(
  () => route.query,
  (query, oldValue) => {
    currMenu.value = window.location.search.substring(1);
    isLeaf.value = query.l;
    queryP.value = query;
    getInfo(query);
  },
  {
    immediate: true,
  }
);

// 获取栏目频道详情
function getInfo(query) {
  isLeaf.value == 1 ? getDetail(query) : getList(query);
}

function getDetail(query) {
  getDetailInfo(query).then((res) => {
    if (res.code === 200 && res.data) {
      subMenus.value = res.data.menuVO[1] || {};
      menuName.value =
        (res.data.menuVO[1]?.menuVOS &&
          res.data.menuVO[1].menuVOS[0].menuName) ||
        "";
      textContent.value = res.data.content;
      leftMenu.value = res.data.leftMenuVO[0] || {};
      breadCrumb.value = [];
      res.data.menuVO.forEach((item) => {
        breadCrumb.value.push({
          name: item.menuName,
          path: item.menuUrl,
        });
        if (item.menuVOS !== null) {
          item.menuVOS.forEach((inItem) => {
            breadCrumb.value.push({
              name: inItem.menuName,
              path: inItem.menuUrl,
            });
          });
        }
      });
    } else {
      proxy.$modal.msgError(res.message);
    }
  });
}

function getList() {
  getListContent({
    ...queryP.value,
    ...queryParams.value,
  }).then((res) => {
    if (res.code === 200 && res.data) {
      tableData.value = res.data.records;
      leftMenu.value = res.data.leftMenuVO[0] || {};
      total.value = res.data.totalCount || res.data.total || 0;
      breadCrumb.value = [];
      res.data.menuVO.forEach((item) => {
        breadCrumb.value.push({
          name: item.menuName,
          path: item.menuUrl,
        });
        if (item.menuVOS !== null) {
          item.menuVOS.forEach((inItem) => {
            breadCrumb.value.push({
              name: inItem.menuName,
              path: inItem.menuUrl,
            });
          });
        }
      });
    }
  });
}

function goDetail(url) {
  router.push("/detail?" + url);
}

function goArticle(id) {
  openInNewTab(`/article-detail/${id}`);
}

function openInNewTab(path, query) {
  const url = router.resolve({ path, query }).href;
  window.open(url, "_blank");
}
</script>
